 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01COVER from '@/components/001cover'
 import LOVE_1 from '@/components/love_1'
 import A03TITLEPAGE from '@/components/003titlepage'
 import A04DEDICATION from '@/components/004dedication'
 import A06ACKNOWLEDGMENT from '@/components/006acknowledgment'
 import A07TOC from '@/components/007toc'
 import A08PART1 from '@/components/008part1'
 import A09CHAPTER1 from '@/components/009chapter1'
 import A10CHAPTER2 from '@/components/010chapter2'
 import A11CHAPTER3 from '@/components/011chapter3'
 import A12CHAPTER4 from '@/components/012chapter4'
 import A13CHAPTER5 from '@/components/013chapter5'
 import A14CHAPTER6 from '@/components/014chapter6'
 import A15PART2 from '@/components/015part2'
 import A16CHAPTER7 from '@/components/016chapter7'
 import A17CHAPTER8 from '@/components/017chapter8'
 import A18CHAPTER9 from '@/components/018chapter9'
 import A19CHAPTER10 from '@/components/019chapter10'
 import A20CHAPTER11 from '@/components/020chapter11'
 import A21CHAPTER12 from '@/components/021chapter12'
 import A22CHAPTER13 from '@/components/022chapter13'
 import A23CHAPTER14 from '@/components/023chapter14'
 import A24CHAPTER15 from '@/components/024chapter15'
 import A25PART3 from '@/components/025part3'
 import A26CHAPTER16 from '@/components/026chapter16'
 import A27CHAPTER17 from '@/components/027chapter17'
 import A28CHAPTER18 from '@/components/028chapter18'
 import A29CHAPTER19 from '@/components/029chapter19'
 import A30CHAPTER20 from '@/components/030chapter20'
 import A31CHAPTER21 from '@/components/031chapter21'
 import A32CHAPTER22 from '@/components/032chapter22'
 import A33CHAPTER23 from '@/components/033chapter23'
 import A34CHAPTER24 from '@/components/034chapter24'
 import A35PART4 from '@/components/035part4'
 import A36CHAPTER25 from '@/components/036chapter25'
 import A37CHAPTER26 from '@/components/037chapter26'
 import A38CHAPTER27 from '@/components/038chapter27'
 import A39CHAPTER28 from '@/components/039chapter28'
 import A40CHAPTER29 from '@/components/040chapter29'
 import A41CHAPTER30 from '@/components/041chapter30'
 import A42CHAPTER31 from '@/components/042chapter31'
 import A43CHAPTER32 from '@/components/043chapter32'
 import A44PART5 from '@/components/044part5'
 import A45CHAPTER33 from '@/components/045chapter33'
 import A46CHAPTER34 from '@/components/046chapter34'
 import A47CHAPTER35 from '@/components/047chapter35'
 import A48CHAPTER36 from '@/components/048chapter36'
 import A49CHAPTER37 from '@/components/049chapter37'
 import A50CHAPTER38 from '@/components/050chapter38'
 import A51CHAPTER39 from '@/components/051chapter39'
 import A52CHAPTER40 from '@/components/052chapter40'
 import A53CHAPTER41 from '@/components/053chapter41'
 import A54PART6 from '@/components/054part6'
 import A55CHAPTER42 from '@/components/055chapter42'
 import A56CHAPTER43 from '@/components/056chapter43'
 import A57CHAPTER44 from '@/components/057chapter44'
 import A58CHAPTER45 from '@/components/058chapter45'
 import A59CHAPTER46 from '@/components/059chapter46'
 import A60CHAPTER47 from '@/components/060chapter47'
 import A61CHAPTER48 from '@/components/061chapter48'
 import A62CHAPTER49 from '@/components/062chapter49'
 import A63CHAPTER50 from '@/components/063chapter50'
 import A64CHAPTER51 from '@/components/064chapter51'
 import A65PART7 from '@/components/065part7'
 import A66CHAPTER52 from '@/components/066chapter52'
 import A67CHAPTER53 from '@/components/067chapter53'
 import A68CHAPTER54 from '@/components/068chapter54'
 import A69CHAPTER55 from '@/components/069chapter55'
 import A70CHAPTER56 from '@/components/070chapter56'
 import A71CHAPTER57 from '@/components/071chapter57'
 import A72CHAPTER58 from '@/components/072chapter58'
 import A73CHAPTER59 from '@/components/073chapter59'
 import A74CHAPTER60 from '@/components/074chapter60'
 import A75PART8 from '@/components/075part8'
 import A76CHAPTER61 from '@/components/076chapter61'
 import A77CHAPTER62 from '@/components/077chapter62'
 import A78CHAPTER63 from '@/components/078chapter63'
 import A79CHAPTER64 from '@/components/079chapter64'
 import LOVE_2 from '@/components/love_2'
 import A80INDEX from '@/components/080index'
 import A05COPYRIGHT from '@/components/005copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/001cover",
 			"name" : "001cover",
 			"component" : A01COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/003titlepage",
 			"name" : "003titlepage",
 			"component" : A03TITLEPAGE
 		},
 		{
 			"path" : "/004dedication",
 			"name" : "004dedication",
 			"component" : A04DEDICATION
 		},
 		{
 			"path" : "/006acknowledgment",
 			"name" : "006acknowledgment",
 			"component" : A06ACKNOWLEDGMENT
 		},
 		{
 			"path" : "/007toc",
 			"name" : "007toc",
 			"component" : A07TOC
 		},
 		{
 			"path" : "/008part1",
 			"name" : "008part1",
 			"component" : A08PART1
 		},
 		{
 			"path" : "/009chapter1",
 			"name" : "009chapter1",
 			"component" : A09CHAPTER1
 		},
 		{
 			"path" : "/010chapter2",
 			"name" : "010chapter2",
 			"component" : A10CHAPTER2
 		},
 		{
 			"path" : "/011chapter3",
 			"name" : "011chapter3",
 			"component" : A11CHAPTER3
 		},
 		{
 			"path" : "/012chapter4",
 			"name" : "012chapter4",
 			"component" : A12CHAPTER4
 		},
 		{
 			"path" : "/013chapter5",
 			"name" : "013chapter5",
 			"component" : A13CHAPTER5
 		},
 		{
 			"path" : "/014chapter6",
 			"name" : "014chapter6",
 			"component" : A14CHAPTER6
 		},
 		{
 			"path" : "/015part2",
 			"name" : "015part2",
 			"component" : A15PART2
 		},
 		{
 			"path" : "/016chapter7",
 			"name" : "016chapter7",
 			"component" : A16CHAPTER7
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js